import { fetchData } from '../../../../services/apiClient';
import { API_ENDPOINTS } from '../../../../services/ApiConfig';

export type ReviewTableResponse = Record<string, any>[];

export const fetchReviewTableData = async (payload: any): Promise<ReviewTableResponse> => {
  return fetchData<ReviewTableResponse>(API_ENDPOINTS.SCENARIO_INPUT.REVIEW_TABLE_KPI_CALCULATION, payload);
};

export const fetchNlpReviewTableData = async (payload: any): Promise<ReviewTableResponse> => {
  return fetchData<ReviewTableResponse>(API_ENDPOINTS.SCENARIO_INPUT.REVIEW_TABLE_KPI_CALCULATION_NLP, payload);
};
